import { render, staticRenderFns } from "./CancerCoachingHome.vue?vue&type=template&id=5563e72e"
import script from "./CancerCoachingHome.vue?vue&type=script&lang=js"
export * from "./CancerCoachingHome.vue?vue&type=script&lang=js"
import style0 from "./CancerCoachingHome.vue?vue&type=style&index=0&id=5563e72e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports